import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { getSelectedEventsDetails } from "../../store/auth/selectors";
import examNavLogo from "../../assets/svg/exampage/examNavLogo.svg";
import il from "../../assets/svg/exampage/il.svg";

export const ExamPageNav = () => {
  const [isMobile, setIsMobile] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const examdetailes = useSelector(getSelectedEventsDetails);

  // Simple conditional logic
  const isYouthChallengeOnReports =
    location.pathname.includes("/reports/") &&
    examdetailes?.title?.toLowerCase() === "youth entrepreneurship challenge";

  const examLogo = isYouthChallengeOnReports ? il : examNavLogo;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setIsMobile(true);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogoClick = () => {
    history.push("/dashboard");
  };

  return (
    <>
      {!isMobile && (
        <nav className="examNavbar">
          <img className="examNavLogo" onClick={handleLogoClick} src={examLogo} alt="logo" />
        </nav>
      )}
    </>
  );
};
